import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ParentComponentApi} from '../profile/profile.component';
import {DxFormComponent} from 'devextreme-angular';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http'; 
import { Configuration } from '../../../app.constants';
import {HelperService} from '../../../shared/services/helper.service';
import { compilePipeFromMetadata } from '@angular/compiler';
import {OtherCoursesInfoService,personalinformation} from '../../services/OtherCoursesInfo.service';
import { ImageUploadService } from '../../../shared/services/image-upload.service';

@Component({
  selector: 'OtherCoursesInfo',
  templateUrl: './OtherCoursesInfo.component.html',
  styleUrls: ['./OtherCoursesInfo.component.scss']
})
export class OtherCoursesInfoComponent implements OnInit {

  @ViewChild(DxFormComponent) PhysicalcertificateForm: DxFormComponent;
  OtherCoursesInfoData:personalinformation;

  value: any[] = [];
  urlDoc: string;
  popupVisible: boolean;
  popupTitle: string;

  showButtons:boolean=false;
  loadIndicatorVisible:boolean=false;
  readOnly: boolean = false;
  documentId: string;
  
  isValid: boolean; 
  SaveBtnDisabled: boolean;
  DeleteBtnDisabled :boolean;
  //OtherCoursesInfoData:BankDetails;
  errorMessage: string[] = new Array(); 
  dataSource:any;  
  DocumentsList:any;
  LanguageLabel:any;
  PreStudentPhyInfoID:0;
  namePattern: any = /^[^0-9]+$/;
  Pattern1: any =/^[^<>]+$/;
  maxYear=0;
  BirthYear=0;
  
  constructor(private http:HttpClient,
    private router: Router,private route: ActivatedRoute, 
    private OtherCoursesInfoService:OtherCoursesInfoService, 
    private configuration: Configuration,private helperService:HelperService 
    )  { 
      this.maxYear = (new Date()).getFullYear();
    }

  ngOnInit() {
    this.LanguageLabel =this.configuration.LanguageLabel[0];
    this.clearData();


    
    this.OtherCoursesInfoService.GetPreStudentInformationForCertificateInfo(this.configuration.CollegeID, 0, 0, 0, this.configuration.AcademicInstanceID, 0, this.configuration.StudentID) 
    .subscribe((data: personalinformation[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => { debugger        
        if(this.dataSource.length>0){
            this.OtherCoursesInfoData=this.dataSource[0];  
            this.OtherCoursesInfoData.BirthYear=this.dataSource[0].BirthYear;
            this.BirthYear = this.dataSource[0].BirthYear; 
            if(this.dataSource[0].StudentCourseID > 0){
              this.SaveBtnDisabled = false;         
              this.DeleteBtnDisabled = true;
              this.showButtons = true;               
              this.GetCertificateData();
            }
            else{
              this.showButtons = false;          
              this.SaveBtnDisabled = true;    
              this.DeleteBtnDisabled = true;
              this.helperService.showWarningMessage("You are not able to fill Certificate Details"); 
            }
        }
        else{
          this.SaveBtnDisabled = true;    
          this.DeleteBtnDisabled = true;
        } 
      });  
  }

  getdata(){        
    this.GetCertificateData();
  }
  GetCertificateData()
  {     
    
    this.OtherCoursesInfoService.GetPreStudentInformationForCertificateInfoList(this.configuration.CollegeID, 0, 0, 0, this.configuration.AcademicInstanceID, 0, this.configuration.StudentID) 
    .subscribe((data: personalinformation[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => { debugger
        if(this.dataSource.length>0){
          this.DocumentsList=this.dataSource; 
        } 
      });
  }
  
  saveRecord() {
    if ((this.configuration.StudentID==null)||(this.configuration.StudentID==0))
    {
      this.helperService.showSuccessMessage("Blank Student Id Not Allowed.");
      return false;    
    }
if (this.OtherCoursesInfoData.OthCourseName == null || this.OtherCoursesInfoData.OthCourseName == "" || this.OtherCoursesInfoData.OthCourseName == undefined) {
      this.helperService.showWarningMessage("Enter Course Name.")
      return false;
    }

    
    if (this.OtherCoursesInfoData.OthCourseAuthority == null || this.OtherCoursesInfoData.OthCourseAuthority == "" || this.OtherCoursesInfoData.OthCourseAuthority == undefined) {
      this.OtherCoursesInfoData.OthCourseAuthority = null;
    }
    
    if (this.OtherCoursesInfoData.OthCourseYear == null || this.OtherCoursesInfoData.OthCourseYear == "" || this.OtherCoursesInfoData.OthCourseYear == undefined) {
      this.OtherCoursesInfoData.OthCourseYear = null;
    } 
    if (this.OtherCoursesInfoData.OthCourseGrade == null || this.OtherCoursesInfoData.OthCourseGrade == "" || this.OtherCoursesInfoData.OthCourseGrade == undefined) {
      this.OtherCoursesInfoData.OthCourseGrade = null;
    }
    
    this.OtherCoursesInfoData.CreatedLoginID = this.configuration.CreatedLoginID;
    this.OtherCoursesInfoData.UpdatedLoginID = this.configuration.UpdatedLoginID;
    this.OtherCoursesInfoData.AcademicInstanceID = this.configuration.AcademicInstanceID;


    this.isValid = this.PhysicalcertificateForm.instance.validate().isValid;
    if(this.isValid == true) {  
      this.errorMessage=[];
      debugger; 
      if(this.OtherCoursesInfoData.PreStudentOtherCourseID > 0 ){
        this.OtherCoursesInfoData.StudentID=this.configuration.StudentID;
       this.OtherCoursesInfoService.PostCertificateInfo(this.OtherCoursesInfoData)
         .subscribe(value => {
           this.onSuccessSave();
         },
           err => {
             this.errorMessage=this.helperService.getErrorMessage(err);
             this.helperService.showSuccessMessage("Not Saved.");    
           },
           () => {
           
           });

      }
      else{
        this.OtherCoursesInfoData.StudentID=this.configuration.StudentID;
       this.OtherCoursesInfoService.PostInsertCertificateInfo(this.OtherCoursesInfoData)
         .subscribe(value => {
           this.onSuccessSave();
         },
           err => {
             this.errorMessage=this.helperService.getErrorMessage(err);
             this.helperService.showSuccessMessage("Not Saved.");    
           },
           () => {
           
           });

      }
    }
  }
  deleteRecord() {
    this.OtherCoursesInfoData.StudentID=this.configuration.StudentID;
    this.OtherCoursesInfoData.UpdatedLoginID = this.configuration.UpdatedLoginID;
    this.OtherCoursesInfoData.AcademicInstanceID = this.configuration.AcademicInstanceID;
   this.OtherCoursesInfoService.PostDeleteCertificateInfo(this.OtherCoursesInfoData)
     .subscribe(value => {
      this.helperService.showSuccessMessage("Deleted Successfully."); 
      this.GetCertificateData();
      this.OtherCoursesInfoData.PreStudentOtherCourseID  = 0; 
       this.OtherCoursesInfoData.OthCourseName           =  "";
       this.OtherCoursesInfoData.OthCourseAuthority      =  "";
       this.OtherCoursesInfoData.OthCourseYear           =  "";
       this.OtherCoursesInfoData.OthCourseGrade          =  "";
       this.OtherCoursesInfoData.OthCourseCert           =  "";  
       this.DeleteBtnDisabled = true;
     },
       err => {
         this.errorMessage=this.helperService.getErrorMessage(err);
         this.helperService.showSuccessMessage("Not Deleted.");    
       },
       () => {
       
       });
  }
  
  cancelClick(){
    this.SaveBtnDisabled = false;    
    this.DeleteBtnDisabled = false;
    this.errorMessage=[];
    this.router.navigate(['/login-form']);
  }

  clearData(){     
   }

   onSuccessSave() {         
    this.GetCertificateData();
    this.OtherCoursesInfoData.PreStudentOtherCourseID  = 0;
     this.helperService.showSuccessMessage("Saved Successfully.");   
     this.OtherCoursesInfoData.OthCourseName           =  "";
     this.OtherCoursesInfoData.OthCourseAuthority      =  "";
     this.OtherCoursesInfoData.OthCourseYear           =  "";
     this.OtherCoursesInfoData.OthCourseGrade          =  "";
     this.OtherCoursesInfoData.OthCourseCert           =  "";  
     this.DeleteBtnDisabled = true;
   }
   
  viewPdfDocument(data) {
    debugger
    if (data.key.OthCourseCert.length > 0) {
      this.documentId = data.key.PreStudentOtherCourseID;
      this.urlDoc = data.key.OthCourseCert ;
      this.openWindow();
    }
  }
  
  openWindow() {
    this.popupTitle = this.LanguageLabel.View;
    this.errorMessage = [];
    this.showInfo();
  }
  showInfo() {
    this.popupVisible = true;
  }
  popupHiding(e) {
    this.errorMessage = [];
  };


	EditClicked(e) {  
    this.OtherCoursesInfoData.PreStudentOtherCourseID =  e.data.PreStudentOtherCourseID;
    this.OtherCoursesInfoData.StudentID               =  e.data.StudentID              ;
    this.OtherCoursesInfoData.OthCourseName           =  e.data.OthCourseName          ;
    this.OtherCoursesInfoData.OthCourseAuthority      =  e.data.OthCourseAuthority     ;
    this.OtherCoursesInfoData.OthCourseYear           =  e.data.OthCourseYear          ;
    this.OtherCoursesInfoData.OthCourseGrade          =  e.data.OthCourseGrade         ;
    this.OtherCoursesInfoData.OthCourseCert           =  e.data.OthCourseCert			;
    if( e.data.PreStudentOtherCourseID > 0)
      {             
        this.DeleteBtnDisabled = false;
      }
      else
      {             
        this.DeleteBtnDisabled = true;
      }
    }

    
  removeDocument(data) {
    if (data.key.OthCourseCert.length > 0) {
      var deleteDocument = {
        "PreStudentOtherCourseID": data.key.PreStudentOtherCourseID,
        "UpdatedLoginID": this.configuration.UpdatedLoginID,
        "StudentID": this.configuration.StudentID 
      }
     debugger;
      this.OtherCoursesInfoService.PostRemovedExtraCertificate(deleteDocument)    
          .subscribe(value => {
           this.getdata();
           this.helperService.showSuccessMessage("File Deleted Successfully.");
        },
          error => {
            alert(error);
          },
          () => {
           
          });
    }
    
  }
}
